// extracted by mini-css-extract-plugin
export default {"modalBody":"EstimateBasisModal_modalBody__owhfb","gridBody":"EstimateBasisModal_gridBody__Ee3Pz","tabs":"EstimateBasisModal_tabs__6vLry"};